import React from 'react'
import BadgeUI from '../../../widgets/output/BadgeUI'
import SearchUI from '../../../widgets/input/SearchUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowLinkUI from '../../../widgets/layout/LRTableRowLinkUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
// import './InvoiceList.css'

const InvoiceListUI = ({ context, messageList, invoiceList,
  searchFilter, onRefreshClick, onSearchFilterChange, onCreateClick
}) =>
  <div className='inv_invoices g_m_top_100'>

    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <LRTableBodyUI className='data_tbl'>
      {
        invoiceList.map((invoice, i) =>
          <InvoiceRowUI key={i} context={context} messageList={messageList} invoice={invoice} />
        )
      }
    </LRTableBodyUI>
  </div>

const InvoiceRowUI = ({ context, invoice, messageList }) =>
  <LRTableRowLinkUI
    context={context}
    to={`/invoices/${invoice.customerInvoiceId}`}
    left={<RowLeftUI context={context} messageList={messageList} invoice={invoice} />}
    right={<RowRightUI context={context} messageList={messageList} invoice={invoice} />}
  />

const RowLeftUI = ({ context, messageList, invoice }) =>
  <div>
    <div className='g_small g_muted'>
      {invoice.invoiceDateF1}
    </div>
    {invoice.invoiceNo}
    <div className='g_m_top_50'>
      {
        invoice.status === 'unpaid' && invoice.lastSentDate &&
        <LabelAndValueUI messageList={messageList} labelKey='c_last_sent'>
          <span className='g_small'>{invoice.lastSentDateF1}</span>
        </LabelAndValueUI>
      }
      {
        invoice.status === 'paid' &&
        <LabelAndValueUI messageList={messageList} labelKey='c_status_paid'>
          <span className='g_small'>{invoice.paymentDateF1}</span>
        </LabelAndValueUI>
      }
      {
        invoice.status === 'cancelled' &&
        <LabelAndValueUI messageList={messageList} labelKey='c_cancelled'>
          <span className='g_small'>{invoice.cancelDateF1}</span>
        </LabelAndValueUI>
      }
    </div>
  </div>

const RowRightUI = ({ context, messageList, invoice }) =>
  <div className='g_text_right'>
    {
      invoice.status === 'unpaid' &&
      <BadgeUI messageList={messageList} labelKey='c_status_unpaid' />
    }
    {
      invoice.status === 'paid' &&
      <BadgeUI messageList={messageList} labelKey='c_status_paid' />
    }
    {
      invoice.status === 'cancelled' &&
      <BadgeUI messageList={messageList} labelKey='c_cancelled' />
    }
    <div className='g_m_top_100'>
      {invoice.invoiceTotalF2}
    </div>
  </div>

const ActionLeftUI = ({ context, messageList, onRefreshClick, onCreateClick
}) =>
  <div className='g_flex_h'>
    <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
    {
      context.permissions && context.permissions.includes('acc_manage') &&
      <IconButtonUI messageList={messageList} icon='icon-plus' onClick={onCreateClick} labelKey='c_create_invoice' />
    }
  </div>

const ActionTopRightUI = ({ context, messageList, searchFilter, onSearchFilterChange
}) =>
  <div className='g_flex_h'>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

export default InvoiceListUI
